import { createSlice } from "@reduxjs/toolkit";
import { HelpDialogProps } from "./HelpDialog";
import { ReleaseDetailsDialogProps } from "../system/releases/ReleaseDetailsDialog";

export type AppDialogState
    = { tag: 'none' }
    | { tag: 'help' , props: HelpDialogProps }
    | { tag: 'releaseDetails' , props: ReleaseDetailsDialogProps }

const initialState = { tag: 'none' } as AppDialogState

export const dialogSlice = createSlice({
    name: "dialog",
    initialState,
    reducers: {
        hideDialog: (state) => {
            state = { tag: 'none' }
        },
        showDialog: (state, action) => {
            state.tag = action.payload.tag
            if (state.tag === 'help' || state.tag === 'releaseDetails') {
                state.props = action.payload.props
            }
        }
    }
})

export const { showDialog, hideDialog } = dialogSlice.actions

export default dialogSlice.reducer

